/**
 * Nombre presentable de la tienda de origen de un producto.
 *
 * Las fuentes viajan en minúscula ("amazon", "aliexpress"), y escribirlas tal
 * cual en la interfaz queda descuidado.
 */
const NOMBRES = {
    amazon: 'Amazon',
    aliexpress: 'AliExpress',
    ebay: 'eBay',
    temu: 'Temu',
    cj: 'CJ Dropshipping'
};

export function sourceLabel(source) {
    if (!source) return '';
    return NOMBRES[String(source).toLowerCase()] || source;
}

export default sourceLabel;
